// Shared type scale for /v2/certs — matches Layerd-UI ssl-tls (body-2 14/21, body-3 12/18).
// Font: inherit from --layerd-font-sans (public/fonts/rubik.css).

import colors from "../../../../utils/colors";

/** Uppercase labels (hero .k, cert-grid .k, section overlines) */
export const certsOverlineSx = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: colors.neutral[600],
  lineHeight: 1.3,
};

/** Primary UI copy (regular weight — not for stat/grid values) */
export const certsBodySx = {
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "21px",
  color: colors.neutral[1000],
};

/** Secondary / helper text */
export const certsBodySecondarySx = {
  fontSize: 12,
  lineHeight: "18px",
  color: colors.neutral[700],
};

/** Dense rows — row titles / names (settings .name, rec .rec-ttl) */
export const certsBodySmallSx = {
  fontSize: 13,
  lineHeight: "20px",
  color: colors.neutral[1000],
};

/** Emphasized row title only (recommendations, install tiles) — not field values */
export const certsRowTitleSx = {
  ...certsBodySmallSx,
  fontWeight: 600,
};

export const certsCardTitleSx = {
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "21px",
  color: colors.neutral[1000],
};

export const certsSectionTitleSx = {
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "24px",
  color: colors.neutral[1000],
};

/** Hero numerals */
export const certsStatSx = {
  fontSize: 22,
  fontWeight: 700,
  lineHeight: "28px",
  letterSpacing: "-0.01em",
  fontVariantNumeric: "tabular-nums",
  color: colors.neutral[1000],
};

export const certsPillTextSx = {
  fontSize: 12,
  fontWeight: 500,
  lineHeight: "18px",
};

export const certsTabTextSx = (active) => ({
  fontSize: 14,
  fontWeight: active ? 600 : 500,
  lineHeight: "21px",
});

export const certsFieldLabelSx = {
  fontSize: 12,
  lineHeight: "18px",
  color: colors.neutral[600],
};

export const certsFieldValueSx = {
  fontSize: 13,
  lineHeight: "20px",
  fontWeight: 500,
  color: colors.neutral[1000],
};

/** cert-grid .v — field values (medium, not bold) */
export const certsGridValueSx = {
  fontSize: 13.5,
  fontWeight: 500,
  lineHeight: "20px",
  fontVariantNumeric: "tabular-nums",
  color: colors.neutral[1000],
};

/** cert-grid .v.mono — host, serial, algorithms */
export const certsGridMonoValueSx = {
  ...certsGridValueSx,
  fontSize: 12.5,
  fontWeight: 400,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const certsMonoValueSx = {
  ...certsFieldValueSx,
  fontSize: 12,
  wordBreak: "break-all",
};

/** Rating ring center grade — display only */
export const certsGradeDisplaySx = {
  fontWeight: 800,
  fontSize: 30,
  lineHeight: 1,
  letterSpacing: "-0.02em",
};
